<div class="conn-card">
    <app-report-top-filter-bar *ngIf="1==1"
        [paraReportName]="'daily-sales-report'"
        (filterCallbackFunc)="callbackFuncFromFilter($event)"
        (filterCallbackFuncUpdateFilter)="filterButtonPressed()"
        (exportExcelFn)="exportExcel()"
        (exportPdfFn)="exportPdf()"
        (exportCsvFn)="exportCsv()"
    ></app-report-top-filter-bar>

    <div class="daily-sales-mobile" *ngIf="useNewMobileLayout && dataList?.length > 0">
        <div class="daily-sales-card" *ngFor="let product of dataList; let i = index">
            <div class="daily-sales-card__header">
                <div class="daily-sales-card__date">{{product.date | date:'MM/dd'}}</div>
                <div class="daily-sales-card__location">{{ product.locationName }}</div>
            </div>
            <div class="daily-sales-card__meta">
                <div class="daily-sales-card__meta-item">
                    <span class="daily-sales-card__meta-text">Invoices {{ product.totalInvoices | number }}</span>
                </div>
                <div class="daily-sales-card__meta-item">
                    <span class="daily-sales-card__meta-text">Sold Items {{ product.totalSaleItems | number }}</span>
                </div>
            </div>
            <button type="button" class="daily-sales-card__toggle" (click)="toggleDetails(i)" [attr.aria-expanded]="isDetailsExpanded(i)">
                <span class="daily-sales-card__toggle-label">
                    View Details
                    <span class="daily-sales-card__chevron" [class.is-open]="isDetailsExpanded(i)">></span>
                </span>
                <span class="daily-sales-card__amount">{{ product.grandTotal | currency | currencySpacing }}</span>
            </button>
            <div class="daily-sales-card__details" *ngIf="isDetailsExpanded(i)">
                <div class="daily-sales-card__detail-row">
                    <span>Return Items</span>
                    <span>{{ (product.totalReturnItems || 0) | number }}</span>
                </div>
                <div class="daily-sales-card__detail-row">
                    <span>Void Items</span>
                    <span>{{ (product.totalVoidItems || 0) | number }}</span>
                </div>
                <div class="daily-sales-card__detail-row">
                    <span>Subtotal</span>
                    <span>{{ product.subTotal | currency | currencySpacing }}</span>
                </div>
                <div class="daily-sales-card__detail-row">
                    <span>Discount</span>
                    <span>{{ product.discount | currency | currencySpacing }}</span>
                </div>
                <div class="daily-sales-card__detail-row">
                    <span>Net Sales</span>
                    <span>{{ product.netSales | currency | currencySpacing }}</span>
                </div>
                <div class="daily-sales-card__detail-row">
                    <span>Sales Tax</span>
                    <span>{{ product.salesTax | currency | currencySpacing }}</span>
                </div>
                <div class="daily-sales-card__detail-row">
                    <span>Shipping</span>
                    <span>{{ product.shippingAmount | currency | currencySpacing }}</span>
                </div>
                <div class="daily-sales-card__detail-row">
                    <span>Shipping Tax</span>
                    <span>{{ product.shippingTax | currency | currencySpacing }}</span>
                </div>
                <div class="daily-sales-card__detail-row">
                    <span>Other Charges</span>
                    <span>{{ (product.otherChargesAmount || 0) | currency | currencySpacing }}</span>
                </div>
                <div class="daily-sales-card__detail-row" *ngIf="!isOnlineOnly">
                    <span>Tip Amount</span>
                    <span>{{ (product.tipAmount || 0) | currency | currencySpacing }}</span>
                </div>
                <div class="daily-sales-card__detail-row daily-sales-card__detail-row--total">
                    <span>Grand Total</span>
                    <span>{{ product.grandTotal | currency | currencySpacing }}</span>
                </div>
            </div>
        </div>

        <div class="daily-sales-card daily-sales-card--total">
            <div class="daily-sales-card__header">
                <div class="daily-sales-card__title">Total</div>
            </div>
            <div class="daily-sales-card__meta">
                <div class="daily-sales-card__meta-item">
                    <span class="daily-sales-card__meta-text">Invoices {{ totalInvoices | number }}</span>
                </div>
                <div class="daily-sales-card__meta-item">
                    <span class="daily-sales-card__meta-text">Sold Items {{ totalSaleItems | number }}</span>
                </div>
            </div>
            <button type="button" class="daily-sales-card__toggle" (click)="toggleTotalDetails()" [attr.aria-expanded]="totalDetailsExpanded">
                <span class="daily-sales-card__toggle-label">
                    View Details
                    <span class="daily-sales-card__chevron" [class.is-open]="totalDetailsExpanded">></span>
                </span>
                <span class="daily-sales-card__amount">{{ grandTotal | currency | currencySpacing }}</span>
            </button>
            <div class="daily-sales-card__details" *ngIf="totalDetailsExpanded">
                <div class="daily-sales-card__detail-row">
                    <span>Return Items</span>
                    <span>{{ totalReturnItems | number }}</span>
                </div>
                <div class="daily-sales-card__detail-row">
                    <span>Void Items</span>
                    <span>{{ totalVoidItems | number }}</span>
                </div>
                <div class="daily-sales-card__detail-row">
                    <span>Subtotal</span>
                    <span>{{ subTotal | currency | currencySpacing }}</span>
                </div>
                <div class="daily-sales-card__detail-row">
                    <span>Discount</span>
                    <span>{{ discount | currency | currencySpacing }}</span>
                </div>
                <div class="daily-sales-card__detail-row">
                    <span>Net Sales</span>
                    <span>{{ netSalesTotal | currency | currencySpacing }}</span>
                </div>
                <div class="daily-sales-card__detail-row">
                    <span>Sales Tax</span>
                    <span>{{ salesTax | currency | currencySpacing }}</span>
                </div>
                <div class="daily-sales-card__detail-row">
                    <span>Shipping</span>
                    <span>{{ shippingAmount | currency | currencySpacing }}</span>
                </div>
                <div class="daily-sales-card__detail-row">
                    <span>Shipping Tax</span>
                    <span>{{ shippingTax | currency | currencySpacing }}</span>
                </div>
                <div class="daily-sales-card__detail-row">
                    <span>Other Charges</span>
                    <span>{{ totalOtherChargesAmount | currency | currencySpacing }}</span>
                </div>
                <div class="daily-sales-card__detail-row" *ngIf="!isOnlineOnly">
                    <span>Tip Amount</span>
                    <span>{{ tipTotalAmount | currency | currencySpacing }}</span>
                </div>
                <div class="daily-sales-card__detail-row daily-sales-card__detail-row--total">
                    <span>Grand Total</span>
                    <span>{{ grandTotal | currency | currencySpacing }}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="daily-sales-table" [class.daily-sales-table-hidden]="useNewMobileLayout">
        <p-table [value]="dataList" dataKey="name" #dt [columns]="csvcols" styleClass="p-datatable-striped" [tableStyle]="{ width: 'max-content' }"   responsiveLayout="scroll" [autoLayout]="true" *ngIf="dataList?.length > 0">
            <ng-template pTemplate="header">
                <tr>
                    <!-- <th *ngFor="let col of domColHeader">
                        <strong>{{col}}</strong>
                    </th> -->
                    <th pSortableColumn="date" style="text-align: left; vertical-align: middle"><strong>Date</strong> <p-sortIcon field="date"></p-sortIcon></th>
                    <th pSortableColumn="locationName" style="text-align: left; vertical-align: middle"><strong>Location</strong> <p-sortIcon field="locationName"></p-sortIcon></th>
                    <th pSortableColumn="totalInvoices" style="text-align: right; vertical-align: middle"><strong>Invoices</strong> <p-sortIcon fietotalInvoicesld=""></p-sortIcon></th>
                    <th pSortableColumn="totalSaleItems" style="text-align: right; vertical-align: middle"><strong>Sold Items</strong> <p-sortIcon ftotalSaleItemsield=""></p-sortIcon></th>
                    <th pSortableColumn="totalReturnItems" style="text-align: right; vertical-align: middle"><strong>Return Items</strong> <p-sortIcon ftotalReturnItemsield=""></p-sortIcon></th>
                    <th pSortableColumn="totalVoidItems" style="text-align: right; vertical-align: middle"><strong>Void Items</strong> <p-sortIcon field="totalVoidItems"></p-sortIcon></th>
                    <th pSortableColumn="subTotal" style="text-align: right; vertical-align: middle"><strong>SubTotal</strong> <p-sortIcon field="subTotal"></p-sortIcon></th>
                    <th pSortableColumn="discount" style="text-align: right; vertical-align: middle"><strong>Discount</strong> <p-sortIcon field="discount"></p-sortIcon></th>
                    <th style="text-align: right; vertical-align: middle"><strong>Net Sales</strong></th>
                    <th pSortableColumn="salesTax" style="text-align: right; vertical-align: middle"><strong>Sales Tax</strong> <p-sortIcon field="salesTax"></p-sortIcon></th>
                    <th pSortableColumn="shippingAmount" style="text-align: right; vertical-align: middle"><strong>Shipping</strong> <p-sortIcon field="shippingAmount"></p-sortIcon></th>
                    <th pSortableColumn="shippingTax" style="text-align: right; vertical-align: middle"><strong>Shipping Tax</strong> <p-sortIcon field="shippingTax"></p-sortIcon></th>
                    <th pSortableColumn="otherChargesAmount" style="text-align: right; vertical-align: middle"><strong>Other Charges</strong> <p-sortIcon field="otherChargesAmount"></p-sortIcon></th>
                    <th pSortableColumn="tipAmount" *ngIf="!isOnlineOnly" style="text-align: right; vertical-align: middle"><strong>Tip Amount</strong> <p-sortIcon field="tipAmount"></p-sortIcon></th>
                    <th pSortableColumn="grandTotal" style="text-align: right; vertical-align: middle"><strong>Grand Total</strong> <p-sortIcon field="grandTotal"></p-sortIcon></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product let-expanded="expanded">
                <tr>
                    <td style="text-align: left; vertical-align: middle">{{product.date | date:'MM/dd/yyyy'}}</td>
                    <td style="text-align: left; vertical-align: middle">{{ product.locationName }}</td>
                    <td style="text-align: right; vertical-align: middle">{{ product.totalInvoices | number }}</td>
                    <td style="text-align: right; vertical-align: middle">{{ product.totalSaleItems | number }}</td>
                    <td style="text-align: right; vertical-align: middle">{{ product.totalReturnItems | number }}</td>
                    <td style="text-align: right; vertical-align: middle">{{ product.totalVoidItems | number }}</td>
                    <td style="text-align: right; vertical-align: middle">{{ product.subTotal | currency | currencySpacing }}</td>
                    <td style="text-align: right; vertical-align: middle">{{ product.discount | currency | currencySpacing }}</td>
                    <td style="text-align: right; vertical-align: middle">{{ product.subTotal-product.discount | currency | currencySpacing }}</td>
                    <td style="text-align: right; vertical-align: middle">{{ product.salesTax | currency | currencySpacing }}</td>
                    <td style="text-align: right; vertical-align: middle">{{ product.shippingAmount | currency | currencySpacing }}</td>
                    <td style="text-align: right; vertical-align: middle">{{ product.shippingTax | currency | currencySpacing }}</td>
                    <td style="text-align: right; vertical-align: middle">{{ product.otherChargesAmount | currency | currencySpacing }}</td>
                    <td *ngIf="!isOnlineOnly" style="text-align: right; vertical-align: middle">{{ product.tipAmount | currency | currencySpacing }}</td>
                    <td style="text-align: right; vertical-align: middle">{{ product.grandTotal | currency | currencySpacing }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <tr *ngIf="dataList?.length > 0">
                    <td colspan="2" style="text-align: left; vertical-align: middle"><strong>Total</strong></td>
                    <td *ngFor="let col of domSummaryflds" style="text-align: right; vertical-align: middle"><strong>{{calculateSummaryTotal(col)}}</strong></td>
                </tr>
            </ng-template>

        </p-table>
    </div>
    <div class="flex" *ngIf="dataList?.length==0">
        <div class="flex justify-content-center" style="width: 100%">
            <span class="control-description text-muted text-align-center"> No data found!</span>
        </div>
    </div>

</div>
